import { AlarmNotificationsType } from "../../services/alarm-data-service/Models";

export const keys = {
    all: ["alarm-data"],
    
    alarmSetPointNotificationCounts: (
        type: AlarmNotificationsType,
        organizationID: number,
        contextGroupID: number,
        //queryParams: IQueryAlarmNotificationParams
        stateDate: Date,
        endDate: Date
        ) => [
            ...keys.all,
            "alarm-setpoint-notification-counts", {
                type,
                organizationID,
                contextGroupID,
                //queryParams
                stateDate,
                endDate
            }
        ],

        alarmNotificationCounts: (
            organizationID: number,
            contextGroupID: number,
            //queryParams: IQueryAlarmNotificationParams
            startDate: Date,
            endDate: Date
            ) => [
                ...keys.all,
                "alarm-notification-counts", {
                    organizationID,
                    contextGroupID,
                    //queryParams
                    startDate,
                    endDate
                }
            ],
        alarmNotificationDetail: (
            organizationID: number,
            contextGroupID: number,
            //queryParams: IQueryAlarmNotificationParams
            startDate: Date,
            endDate: Date
            ) => [
                ...keys.all,
                "alarm-notification-detail", {
                    organizationID,
                    contextGroupID,
                    //queryParams
                    startDate,
                    endDate
                }
            ],
                            
        
};

